import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
import { logout } from "../_redux/authCrud";

class Logout extends Component {
  componentDidMount() {
    setTimeout(() => {
      logout()
        /* .then(({ data: { accessToken } }) => { */
        .then(response => {
          console.log("Logout response", response.data);
          switch (response.data.type) {
            case "SUCCESS":
            case "SUCCESS_WITH_INFO":
            case "SUCCESS_WITH_WARNING":
              //console.log("Logout", response.data.msg);
              break;
            default:
              break;
          }
        })
        .catch(error => {
          console.log("Login error", error);
        });
    }, 1000);
    this.props.logout();
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? (
      <LayoutSplashScreen />
    ) : (
      <Redirect to="/auth/login" />
    );
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
